import { put, select, all, takeEvery } from 'redux-saga/effects';
import { createReducer } from 'typesafe-actions';
import { getCartItem } from './selectors';
import { BASKET_SET, BASKET_UPDATE_ITEM, BasketFlowActions } from './actions';
import { BasketItem } from '../types';
import { BASKET_DELETE_PRODUCTS, BASKET_LOAD, BASKET_SET_PRODUCT } from 'common/constants';

export const basket = createReducer<BasketItem[] | null>(null)
  .handleAction(BASKET_SET, (state, { payload }) => payload)
  .handleAction(BASKET_UPDATE_ITEM, (state, { payload }) => {
    const res = state instanceof Array ? [...state] : [];

    const itemIdx = res.findIndex(({ code }) => code === payload.code);
    if (itemIdx >= 0) {
      res.splice(itemIdx, 1);
    }

    if (payload.quantity > 0) {
      res.push(payload);
    }

    return res;
  });

export function* rootSaga() {
  yield all([
    takeEvery(BasketFlowActions.UPDATE_ITEM, handleBasketItemFlow),
    takeEvery(BasketFlowActions.RESET_ITEM, handleBasketResetItemFlow),
    takeEvery(BasketFlowActions.UPDATE, handleBasketUpdate),
    takeEvery(BasketFlowActions.LOAD, handleBasketLoad),
  ]);
}

// handleBasketItemFlow
export function* handleBasketItemFlow({ payload }: { payload: BasketFlowActions.UpdateItemPayload }) {
  const { code, quantity } = payload;
  document.body.dispatchEvent(new CustomEvent(BASKET_SET_PRODUCT, { detail: { code, quantity } }));
  yield put(BASKET_UPDATE_ITEM({ code, quantity }));
}

function* handleBasketResetItemFlow({ payload }: { payload: BasketFlowActions.ResetItemPayload }) {
  const { code } = payload;
  const basketItem: BasketItem | undefined = yield select(getCartItem(code));
  if (basketItem) {
    document.body.dispatchEvent(new CustomEvent(BASKET_DELETE_PRODUCTS, { detail: [code] }));
    yield put(BasketFlowActions.UPDATE_ITEM({ code, quantity: 0 }));
  }
}

function* handleBasketUpdate({ payload }: { payload: BasketFlowActions.UpdatePayload }) {
  yield put(BASKET_SET(payload));
}

function* handleBasketLoad() {
  document.body.dispatchEvent(new CustomEvent(BASKET_LOAD));
  yield;
}

export function* selectCartItem(productId: string) {
  const item: BasketItem = yield select(getCartItem(productId));
  return item;
}
